<script setup>
import { status } from '../lib/status'

defineProps({
  steps: { type: Array, required: true },
})
</script>

<template>
  <ol class="flex items-start" aria-label="Etapas da manutenção">
    <li
      v-for="(step, i) in steps"
      :key="step.label"
      class="relative flex flex-1 flex-col items-center"
      :aria-current="step.state === 'active' ? 'step' : undefined"
    >
      <!-- Trilho até a etapa seguinte -->
      <span
        v-if="i < steps.length - 1"
        class="absolute left-1/2 top-[11px] h-[3px] w-full"
        :class="steps[i + 1].state === 'pending' ? 'bg-slate-200' : 'bg-up-orange'"
        aria-hidden="true"
      />

      <span
        class="relative z-10 flex h-6 w-6 items-center justify-center rounded-full"
        :class="step.state === 'active'
          ? 'bg-white ring-[3px] ring-up-orange'
          : step.state === 'done' ? 'bg-up-orange' : 'bg-slate-300'"
        aria-hidden="true"
      >
        <span v-if="step.state === 'active'" class="h-2.5 w-2.5 rounded-full bg-up-orange" />
      </span>

      <span
        class="mt-2 text-center text-[11px] leading-tight sm:text-xs"
        :class="step.state === 'active'
          ? 'font-bold text-up-navy'
          : step.state === 'done' ? 'text-slate-600' : 'text-up-gray'"
      >
        {{ step.label }}
        <span class="sr-only"> — {{ status(step.state).label }}</span>
      </span>
    </li>
  </ol>
</template>
